export default __webpack_public_path__ + "static/media/AG1.af385f51.jpg";